import { combineComponents } from "~utils";

import { LastPromptPreferencesPersistenceProvider } from "./last-prompt-preferences";
import { LastPromptPersistenceProvider } from "./last-prompt-shared-formation";
import { LastPromptSignInPersistenceProvider } from "./last-prompt-sign-in";

export const CookiesProvider = combineComponents(
  LastPromptPersistenceProvider,
  LastPromptSignInPersistenceProvider,
  LastPromptPreferencesPersistenceProvider,
);
